import { forwardRef } from "react";
import PropTypes from "prop-types";
import { MenuItem, Link } from "@mui/material";
import { MDBox, MDTypography } from "components";
import menuItem from "components/MDMenuItem/styles";

const MDMenuItem = forwardRef(({ icon, title, onClickAction, ...rest }, ref) => (
  <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme)}>
    <MDBox
      component={Link}
      py={0.5}
      display="flex"
      alignItems="center"
      lineHeight={1}
      onClick={(event) => onClickAction(event)}
    >
      <MDTypography variant="body1" color="secondary" lineHeight={0.75}>
        {icon}
      </MDTypography>
      <MDTypography variant="button" fontWeight="regular" sx={{ ml: 1 }}>
        {title}
      </MDTypography>
    </MDBox>
  </MenuItem>
));

// Typechecking props for the MDMenuItem
MDMenuItem.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default MDMenuItem;
